<script>
  export let props;
</script>

<a
  href="placeholder-to-keep-compiler-happy"
  class="text-green-100 underline"
  {...props}
>
  <slot />
</a>
